import {
  ADD_FAVOURITE,ADD_FAVOURITE_FAIL,ADD_FAVOURITE_SUCCESS,
  GET_FAVOURITE,GET_FAVOURITE_FAIL,GET_FAVOURITE_SUCCESS


} from "./actionTypes"

const INIT_STATE = {
 
  error: "",
  keys_error: "",
  favLoading: false,

  favListing:[]


}

const Faviurite = (state = INIT_STATE, action) => {
  switch (action.type) {

    case ADD_FAVOURITE:
      return {
        ...state,
        favLoading: true,
      }

    case ADD_FAVOURITE_SUCCESS:
      return {
        ...state,
        favLoading: false,
      }

    case ADD_FAVOURITE_FAIL:
      return {
        ...state,
        error: action.payload,
        favLoading: false,
      }

      case GET_FAVOURITE:
        return {
          ...state,
          favLoading: true,
        }
  
      case GET_FAVOURITE_SUCCESS:
        return {
          ...state,
          favLoading: false,
          favListing: action.payload.data || [],
        }
  
      case GET_FAVOURITE_FAIL:
        return {
          ...state,
          error: action.payload,
          favLoading: false,
        }
     
   
    default:
      return state
  }
}

export default Faviurite
